export enum SignStatusEnum {
    naoAssinado = 'N',
    parcialmenteAssinado = 'P',
    totalmenteAssinado = 'A',
}
